export default __webpack_public_path__ + "static/media/center-view.80bd0a63.jpg";